export default "__VITE_ASSET__d749315e__"